import { ImageSetting, useEditorStore } from "dmeditor";
import { DME } from "dmeditor";
import styled from "@emotion/styled";
import { Checkbox } from "@mui/material";
import { useState } from "react";

import { EntityArticleInfo } from "../entity";

const Container = styled.div`
  display: flex;
  align-items: flex-start;

  & label {
    white-space: nowrap;
    margin-right: 40px;
    font-size: 14px;
  }
`;

export const ArticleImage = (
  props: DME.SettingComponentProps<EntityArticleInfo>
) => {
  const { getSelectedBlock, updateSelectedBlock, page, updatePage } =
    useEditorStore();
  const { data } = getSelectedBlock<EntityArticleInfo>() || {};
  const { image } = data || {};

  const handleChange = (value: DME.ImageInfo) => {
    updateSelectedBlock<EntityArticleInfo>((blockData) => {
      blockData.image = value;
    });
    updatePage(value.src, "cover_image");
  };

  return (
    <>
      <Container>
        <label>Image</label>
        <div className="content">
          <ImageSetting
            value={{ src: image?.src || "", id: image?.id }}
            onChange={handleChange}
          />
        </div>
      </Container>
    </>
  );
};
